import React from 'react';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';
import { SeoProps } from './types';

const Seo: React.FC<SeoProps> = ({ title }) => {
  const intl = useIntl();
  const appName = intl.formatMessage({
    id: 'app.name',
    defaultMessage: 'Sandoog',
  });

  return (
    <Helmet>
      <title>{title ? `${appName} | ${title}` : appName}</title>
    </Helmet>
  );
};

export default Seo;
